<textarea
  rows="1"
  class="col-12"
  autosize
  [attr.data-testId]="testId + '-text'"
  [ngModel]="text"
  (ngModelChange)="onGeneratedTextEdited($event)"
></textarea>
